import { useaxios } from "../../../utils/useaxios";
export default (mizania_id) => recaller => setrecaller => initDispatch => clear => {
    initDispatch({ type: 'loadingTrue' });
    useaxios('mizania/delete.php', { mizania_id }).then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        } else if (res == "request_failed") {
            alert('no internet connection');
            initDispatch({ type: 'loadingFalse' });
            return false;
        } else if (res.status == "ok") {
            setrecaller(recaller + 1);
        }
    });
}